import Tabs from "../../branchDepartment/components/tabs";
import { Dialog, DialogContent } from "@mui/material";
import DomainAddOutlinedIcon from "@mui/icons-material/DomainAddOutlined";
import { qrDialogPaperSx, QrModalHeader } from "../../qrCode/components/qrUi";
import { OrganizationCreateForm } from "./organizationCreation";
import { useSelector } from "react-redux";
import CircularLoader from "../../../components/loaders/circularLoader";
import { Box } from "@mui/material";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import { useState, useEffect } from "react";
import CorporateFareRoundedIcon from "@mui/icons-material/CorporateFareRounded";
import NameCardList from "../../branchDepartment/components/nameCardList";

export default function OrganizationList() {
  const { getOrganizations, status, error } = useSelector((state) => state.contacts);


  const [search, setSearch] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (status === "failed") {
      setSnackbar({
        open: true,
        message: error,
        severity: "error",
      });
    }
  }, [status, error]);

  // Same filter as before (only evaluated once the list has loaded)
  const filteredOrganizations = status !== "succeeded" ? [] : getOrganizations.filter((item) => item.organization_name.toLowerCase().includes(search.toLowerCase()));


  return (
    <div>
      <Tabs onCreate={() => setCreateOpen(true)}>
        <Box>
          {/* Loader */}
          {status === "loading" && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularLoader color="success" />
            </Box>
          )}

          {/* Success */}
          {status === "succeeded" && (
            <NameCardList
              items={filteredOrganizations}
              getName={(item) => item.organization_name}
              getId={(item) => item.id}
              search={search}
              onSearchChange={(value) => {
                // no leading space (same rule as before)
                if (!value.startsWith(" ")) {
                  setSearch(value)
                }
              }}
              searchPlaceholder="Search Organization"
              countIcon={<CorporateFareRoundedIcon />}
              countLabel="organization"
              watermark={<CorporateFareRoundedIcon />}
            />
          )}
        </Box>
      </Tabs>
      {/* Create organization popup */}
      <Dialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 460 } } }}
      >
        <QrModalHeader
          icon={<DomainAddOutlinedIcon />}
          title="Create Organization"
          subtitle="Add a new organization to group your contacts"
          onClose={() => setCreateOpen(false)}
        />
        <DialogContent sx={{ p: 0 }}>
          {/* remounts on each open, so the form starts empty */}
          {createOpen && (
            <OrganizationCreateForm
              embedded
              onCancel={() => setCreateOpen(false)}
              onSuccess={(message) => {
                setCreateOpen(false);
                setSnackbar({ open: true, message: message || "Organization created", severity: "success" });
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      <SnackbarMessage open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} />
    </div>
  );
}
